import { FC } from 'react';
import { defaultFnType } from 'types';
import { DetailsType, LinkType } from 'types/tncApi.types';
import insertLinkInText from 'utils/insertLinkInText';

interface TncPendingDetailsType {
  details: DetailsType[];
  links: Record<string, LinkType>;
  handleLinkClick: defaultFnType;
}

const TncPendingDetails: FC<TncPendingDetailsType> = ({ details, links, handleLinkClick }) => {
  return (
    <>
      {details?.map((item, detailsIndex) => (
        <>
          {item?.heading && (
            <div className='f-16-400 tw-mb-2' key={`heading_${detailsIndex}`}>
              {insertLinkInText(item?.heading, links, handleLinkClick)}
            </div>
          )}
          {item?.text && (
            <div className='f-12-300' key={`para_wrapper_${detailsIndex}`}>
              {item?.text?.map((paragrapgh, index) => (
                <div key={`para_${detailsIndex}_${index}`} className='tw-mb-2 last:tw-mb-4'>
                  {insertLinkInText(paragrapgh, links, handleLinkClick)}
                </div>
              ))}
            </div>
          )}
        </>
      ))}
    </>
  );
};

export default TncPendingDetails;
